import { memo } from 'react';
import PropTypes from 'prop-types';

/**
 * The key above a plot: one swatch and label per series.
 *
 * Above rather than beside, because a legend in a side column costs the plot
 * a third of its width, and these widgets are read in slots as narrow as a
 * third of a dashboard.
 *
 * @param {object} props
 * @param {{ label: string, color: string }[]} props.items Series, in plot order.
 * @param {string} [props.className]
 */
function ChartLegend({ items, className = '' }) {
  if (!items.length) return null;

  return (
    <div className={['mb-2 flex flex-wrap gap-3', className].filter(Boolean).join(' ')}>
      {items.map((item) => (
        <span
          key={item.label}
          className="inline-flex items-center gap-1.5 text-[11px] text-content-muted"
        >
          <span
            aria-hidden
            className="h-2 w-2 shrink-0 rounded-sm"
            style={{ background: item.color }}
          />
          {item.label}
        </span>
      ))}
    </div>
  );
}

ChartLegend.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({ label: PropTypes.string.isRequired, color: PropTypes.string.isRequired }),
  ).isRequired,
  className: PropTypes.string,
};

export default memo(ChartLegend);
